import omit from 'lodash/omit';
import routerFactory from '@helpers/routerFactory.js';
import { apiConstants } from './constants';

const apiUtils = {
    normalizeListSuccess: ({ data }) => {
        return {
            success: true,
            data: {
                ...omit(data, 'items'),
                list: data.items,
                totalCount: data.totalCount || null,
                totals: data.totals || null,
                baseCurrency: data.cashBackBaseCurrency || null,
            },
        };
    },
    normalizeListSuccessRaw: ({ data }) => {
        return {
            success: true,
            data: {
                list: data,
                totalCount: 0,
            },
        };
    },
    normalizeSuccess: ({ data }) => {
        return {
            success: true,
            data,
        };
    },
    normalizeError: ({ title, detail, status, violations, code }) => {
        return {
            success: false,
            title: title,
            message: detail,
            code: code,
            details:
                violations && violations.length
                    ? violations.map(({ field, message }) => {
                          return {
                              field,
                              code: message,
                              message: message,
                          };
                      })
                    : null,
            status: status,
        };
    },
    getDefaultGetParams: () => {
        return {
            limit: apiConstants.GET_DEFAULT_PARAMS.LIMIT,
            offset: apiConstants.GET_DEFAULT_PARAMS.OFFSET,
        };
    },
    getDefaultGetParamsCustomer: () => {
        return {
            ...apiUtils.getDefaultGetParams(),
            customer: apiConstants.GET_DEFAULT_PARAMS.CUSTOMER,
        };
    },
    getDefaultGetParamsWithCount: () => {
        return {
            ...apiUtils.getDefaultGetParams(),
            count: false,
        };
    },
    normalizeOptionsArrayToString: (options, key = 'id', joinChar = ',') => {
        if (Array.isArray(options) && options.length) {
            return options.map((item) => item[key]).join(joinChar);
        }
        return null;
    },
    normalizeQueryParams: (data) => {
        return apiUtils.cleanQueryParams({ ...data });
    },
    cleanQueryParams: (params) => {
        const ret = { ...params };

        for (let key in ret) {
            if (ret[key] === null || ret[key] === undefined || ret[key] === '') {
                delete ret[key];
            }
        }

        return ret;
    },
    checkStatusList: (response) => {
        let data = response.data;
        return response.status >= 200 && response.status <= 300
            ? apiUtils.normalizeListSuccess({ data })
            : apiUtils.normalizeError(data);
    },
    checkStatusListRaw: (response) => {
        let data = response.data;
        return response.status >= 200 && response.status <= 300
            ? apiUtils.normalizeListSuccessRaw({ data })
            : apiUtils.normalizeError(data);
    },
    checkStatus: (response) => {
        let data = response.data;
        return response.status >= 200 && response.status <= 300
            ? apiUtils.normalizeSuccess({ data })
            : apiUtils.normalizeError(data);
    },
    checkError: (error) => {
        const securityStatuses = [401, 403];
        const router = routerFactory.create([]);
        const response = apiUtils.normalizeError(
            error.response && error.response.data ? error.response.data : error
        );

        if (
            error.response &&
            securityStatuses.findIndex((item) => item === error.response.status) !== -1 &&
            window.location.pathname !== '/'
        ) {
            router.push({ name: 'theForbidden' });
            return apiUtils.normalizeError({ title: 'Error', detail: 'Forbidden' });
        } else {
            return response;
        }
    },
};

export default apiUtils;
